export default __webpack_public_path__ + "static/media/1da993325ecb2cbfc636e13f2915711e.geojson";